import React from "react";
import SettingsPageWrapper from "../../../shared/SettingsPageWrapper";
import MembershipsTabs from "./MembershipsTabs";

const SettingsMembershipDetails = (props) => {
  const { settingsPath, lastEditedAt, changelogVersions } = props;

  return (
    <SettingsPageWrapper settingsPath={settingsPath} title="Memberships" lastEditedAt={lastEditedAt} changelogVersions={changelogVersions}>
      <MembershipsTabs {...props} />
    </SettingsPageWrapper>
  );
};

export default SettingsMembershipDetails;
